import React from 'react';
import { Star } from 'lucide-react';
import './KeyStar.css';

// The key star, for contacts and accounts alike. A toggle when the viewer
// can change it; otherwise a plain mark that shows only when the record is
// key. `what` names the flag in the labels: "key contact", "key account".
export default function KeyStar({ on, name, onToggle, what = 'key contact', size = 16, disabled = false }) {
  const Label = what.charAt(0).toUpperCase() + what.slice(1);
  if (!onToggle) {
    return on ? <Star size={size} className="key-star on" role="img" aria-label={Label} /> : null;
  }
  return (
    <button
      type="button"
      className={`key-star-button ${on ? 'on' : ''}`}
      onClick={(e) => { e.stopPropagation(); onToggle(!on); }}
      aria-pressed={!!on}
      aria-label={on ? `Unmark ${name} as ${what}` : `Mark ${name} as ${what}`}
      title={on ? Label : `Mark as ${what}`}
      disabled={disabled}
    >
      <Star size={size} aria-hidden="true" />
    </button>
  );
}
